/*
 *   File : onboarding.js
 *   Author : https://evoqins.com
 *   Description : Onboarding page
 *   Integrations :
 *   Version : 1.0.0
 *   Date : 22-09-2022  
*/


import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// *********** Components ***************//  
import { Footer } from "../../Component/Footer"
import { Header } from "../../Component/Navigation"
import { APIService } from "../../Service";
import { VerifyPan, LinkDigiLocker, ReviewDetails, PersonalDetails, AddNominee, ESign, AddBank, BasketList, SetPIN } from "./Helper";
import { _getGeneralData, _getSignupProgress, _getUserData } from "../../Helper";

// *********** Assets ***************//  
import Loader from "../../Assets/Images/loader-blue.gif";


function Onboarding(props) {
    const location = useLocation();
    const is_auth_configured = localStorage.getItem("is_auth_configured") === "true";
    const [currentStep, setCurrentStep] = useState(1);
    const [isNRI, setIsNRI] = useState(location.state ? location.state.is_nri : false);
    const [kycUser, setKycUser] = useState(false);
    const [countryData, setCountryData] = useState([]);
    const [nonKYCLittleMoreDetails, setNonKYCLittleMoreDetails] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let access_token = sessionStorage.getItem('access_token');

        if (access_token) {
            _getSignupProgress().then(response => {
                let data = response.data;
                let is_pan_invalid = data?.step_detail[0].error || false;
                localStorage.setItem("is_auth_configured", data?.is_auth_configured);
                _getCurrentStep(data, is_pan_invalid);
                setKycUser(data.kyc_user);
                setIsNRI(data.kyc_data?.is_nri);
                setLoading(false);
            });
            _getUserData();
            _getGeneralData();
            _getCountry();
        } else {
            setLoading(false);
        }
    }, []);

    function _getCurrentStep(data, is_pan_invalid) {
        if (data?.kyc_user) {
            switch (data?.kyc_data?.status) {
                case "PHONE_OTP_VERIFIED": setCurrentStep(1);
                    break;
                case "PAN_ADDED": setCurrentStep(2);
                    break;
                case "PERSONAL_DETAIL_ADDED": setCurrentStep(3);
                    break;
                case "BANK_ACCOUNT_ADDED": setCurrentStep(4);
                    break;
                case "NOMINEE_ADDED": setCurrentStep(5);
                    break;
                case "BANK_VERIFICATION_PENDING":
                case "ACCOUNT_CREATED": {
                    if (is_auth_configured || data.is_auth_configured) {
                        setCurrentStep(6);
                    } else {
                        setCurrentStep(5);
                    }
                };
                    break;
            }
        }

        if (data?.kyc_user === false) {
            switch (data?.kyc_data?.status) {
                case "PHONE_OTP_VERIFIED": setCurrentStep(1);
                    break;
                case "PAN_ADDED": setCurrentStep(2);
                    break;
                case "PERSONAL_DETAIL_ADDED": setCurrentStep(3);
                    break;
                case "ADDRESS_PROOF": setCurrentStep(4);
                    break;
                case "BANK_ACCOUNT_ADDED": setCurrentStep(5);
                    break;
                case "KYC_ESIGN_REQUIRED":
                case "NOMINEE_ADDED": setCurrentStep(6);
                    break;
                case "KYC_SUBMITTED": setCurrentStep(7);
                    break;
                case "ACCOUNT_CREATED": {
                    if (is_auth_configured === false) {
                        setCurrentStep(7);
                    } else {
                        setCurrentStep(8)
                    }
                };
                    break;
                case "KYC_REJECTED": {
                    if (is_pan_invalid) {
                        setCurrentStep(1);
                    } else {
                        setCurrentStep(2);
                    }
                };
                    break;
                default: setCurrentStep(1);

            }
        }
    };

    // Function to update onboarding step   
    const _handleUpdateCurrentStep = (step, is_kyc_user = "", is_nri = "", non_kyc_little_more_details = "") => {

        setCurrentStep(step);

        if (is_nri !== "") {
            setIsNRI(is_nri);
        }

        if (is_kyc_user !== "") {
            setKycUser(is_kyc_user);
        }

        if (non_kyc_little_more_details !== "") {
            setNonKYCLittleMoreDetails(non_kyc_little_more_details);
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });

    };

    // Function to update onboarding step   
    const _handleBack = (step) => {
        setCurrentStep(step || currentStep - 1);
        setNonKYCLittleMoreDetails(false);
    };

    //API- Get countries
    const _getCountry = () => {
        let is_post = false;
        let url = 'general/countries';
        let data = null;

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setCountryData(response.data);
            } else {
                setCountryData([]);
            }
        });
    };


    return (
        <>
            <section className="e-login-gradient">
                <Header />

                {/* Onboarding Steps */}

                {
                    loading ?
                        <div className="col-sm-10 col-md-9 col-lg-8 col-xl-7 mx-auto px-lg-0">
                            <div className="e-padding-block-40px-res padding-76px-top padding-150px-bottom position-relative">
                                <div className="min-h-100vh text-center mt-5 pt-5" >
                                    <img src={Loader}
                                        className='object-fit-contain w-20 width-24px-res'
                                        draggable="false"
                                        alt="loader" />
                                </div>
                            </div>
                        </div>
                        :


                        kycUser === true ?
                            <>
                                {currentStep === 1 && <VerifyPan isNRI={isNRI} handleUpdateCurrentStep={_handleUpdateCurrentStep} handleBackToSignUp={props.handleBackToSignUp} />}
                                {currentStep === 2 && <ReviewDetails kycUser={kycUser} isNRI={isNRI} countryData={countryData} handleUpdateCurrentStep={_handleUpdateCurrentStep} handleBack={_handleBack} />}
                                {currentStep === 3 && <AddBank kycUser={kycUser} isNRI={isNRI} currentStep={currentStep} handleUpdateCurrentStep={_handleUpdateCurrentStep} handleBack={_handleBack} />}
                                {currentStep === 4 && <AddNominee isNRI={isNRI} kycUser={kycUser} countryData={countryData} handleUpdateCurrentStep={_handleUpdateCurrentStep} handleBack={_handleBack} />}
                                {currentStep === 5 && <SetPIN isNRI={isNRI} kycUser={kycUser} handleUpdateCurrentStep={_handleUpdateCurrentStep} />}
                                {currentStep === 6 && <BasketList />}
                            </>
                            :
                            <>
                                {currentStep === 1 && <VerifyPan isNRI={isNRI} handleUpdateCurrentStep={_handleUpdateCurrentStep} handleBackToSignUp={props.handleBackToSignUp} />}
                                {currentStep === 2 && <ReviewDetails kycUser={kycUser} isNRI={isNRI} countryData={countryData} handleUpdateCurrentStep={_handleUpdateCurrentStep} handleBack={_handleBack} />}
                                {currentStep === 3 && <LinkDigiLocker kycUser={kycUser} handleUpdateCurrentStep={_handleUpdateCurrentStep} handleBack={_handleBack} />}
                                {currentStep === 4 && <AddBank kycUser={kycUser} isNRI={isNRI} currentStep={currentStep} handleUpdateCurrentStep={_handleUpdateCurrentStep} handleBack={_handleBack} />}
                                {currentStep === 5 && <AddNominee isNRI={isNRI} kycUser={kycUser} countryData={countryData} handleUpdateCurrentStep={_handleUpdateCurrentStep} handleBack={_handleBack} />}
                                {currentStep === 6 && <ESign handleUpdateCurrentStep={_handleUpdateCurrentStep} handleBack={_handleBack} />}
                                {currentStep === 7 && <SetPIN isNRI={isNRI} kycUser={kycUser} handleUpdateCurrentStep={_handleUpdateCurrentStep} handleBackToSignUp={props.handleBackToSignUp} />}
                                {currentStep === 8 && <BasketList />}
                            </>
                }

                {/* footer section  */}
                <div className="e-bg-anti-flash-white">
                    <Footer auth={true} />
                </div>

            </section>
        </>
    )
}

export default Onboarding